import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CTASectionProps {
  title?: string;
  subtitle?: string;
}

export const CTASection = ({
  title = "Ready to Transform Your Lawn?",
  subtitle = "Get in touch today for a free estimate on lawn care, landscaping, or snow removal services.",
}: CTASectionProps) => {
  return (
    <section className="cta-section" aria-labelledby="cta-heading">
      <div className="container mx-auto px-4 text-center">
        <h2 id="cta-heading" className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
          {title}
        </h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <Button size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold px-8">
              Get a Free Quote <ArrowRight className="w-5 h-5 ml-2" aria-hidden="true" />
            </Button>
          </Link>
          <a href="tel:+17632457813" aria-label="Call Riekels at (763) 245-7813">
            <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold px-8">
              <Phone className="w-5 h-5 mr-2" aria-hidden="true" /> (763) 245-7813
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
